import { actionsTypes } from '../constants/loadMenuDataConstants'


export function fetchApiSuccess(data) {
  return {
    type: actionsTypes.LOADING_DATA_SUCCESS,
    data
  }
}

export function fetchApiFail(error) {
  return {
    type: actionsTypes.LOADING_DATA_ERROR,
    error
  }
}


export function fetchApiRequest(storeCode) {
  return {
    type: actionsTypes.LOADING_DATA_REQUESTED,
    storeCode
  }
}

